const ENV = import.meta.env.VITE_APP_TYPE || 'DEV'
export const USER_TOKEN = `${ENV}:userToken`
export const USER_NAME = `${ENV}:userName`
// redux-persist config key (store/index.js) — env-scoped like the auth keys so
// persisted permissions can't bleed across env builds on a shared origin.
export const PERSIST_KEY = `${ENV}:root`
// The actual localStorage key redux-persist writes ('persist:' + config key).
export const PERSIST_DATA = `persist:${PERSIST_KEY}`
const IMPERSONATION_KEY = 'impersonation'
var cacheData = {}

const ALL_SAVE = [USER_TOKEN, USER_NAME]

// The token this tab's session was established with: set by a login in this
// tab, or adopted from storage on first read. localStorage is shared across
// tabs, so after another tab re-logs-in, getAuthToken() returns the NEW token
// while this tab's session was built on the old one — authProvider.logout
// compares the two so a stale tab can never archive a session it doesn't own.
let tabSessionToken = null

const clearData = () => {
  cacheData = {}
  tabSessionToken = null
  ALL_SAVE.forEach((key) => localStorage.removeItem(key))
}

// Invalidate in-memory cache when another tab modifies auth keys
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    if (event.key && ALL_SAVE.includes(event.key)) {
      cacheData = {}
    }
  })
}

function getAuthToken() {
  if (cacheData[USER_TOKEN]) return cacheData[USER_TOKEN]
  const token = JSON.parse(localStorage.getItem(USER_TOKEN))
  if (token && !tabSessionToken) tabSessionToken = token
  return token
}
function setAuthToken(UserToken) {
  tabSessionToken = UserToken
  cacheData[USER_TOKEN] = UserToken
  localStorage.setItem(USER_TOKEN, JSON.stringify(UserToken))
}
function getTabSessionToken() {
  return tabSessionToken
}

function getUserName() {
  if (cacheData[USER_NAME]) return cacheData[USER_NAME]
  return JSON.parse(localStorage.getItem(USER_NAME))
}
function setUserName(userName) {
  cacheData[USER_NAME] = userName
  localStorage.setItem(USER_NAME, JSON.stringify(userName))
}

function setAuth(UserToken, UserName) {
  setAuthToken(UserToken)
  setUserName(UserName)
}

const removeAuthToken = () => {
  clearData()
}

// function refreshNewToken() {
//   const storage = getAuthToken();
//   const data = refreshToken(storage.refreshToken);
//   return data;
// }

function setImpersonation(info) {
  cacheData[IMPERSONATION_KEY] = info
  localStorage.setItem(IMPERSONATION_KEY, JSON.stringify(info))
}

function getImpersonation() {
  if (cacheData[IMPERSONATION_KEY]) return cacheData[IMPERSONATION_KEY]
  return JSON.parse(localStorage.getItem(IMPERSONATION_KEY))
}

function clearImpersonation() {
  delete cacheData[IMPERSONATION_KEY]
  localStorage.removeItem(IMPERSONATION_KEY)
}

export { getAuthToken, getUserName, setAuth, removeAuthToken, setAuthToken, getTabSessionToken, setImpersonation, getImpersonation, clearImpersonation }
